export enum ChartFontColors {
  Gray900 = '#262527'
}
